import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInput from "../../../components/forms/CommonInput";
import {
  handleChange,
  handleChangeFile,
  handleChangeUnmask,
} from "../../../helpers/handleFormChanges";
import PropTypes from "prop-types";
import CommonInputMask from "../../../components/forms/CommonInputMask";
import CommonInputSenha from "../../../components/forms/CommonInputSenha";
import CommonInputFile from "../../../components/forms/CommonInputFile";

function FinalizarMeiModal({ modalHook, valuesHook, finalizarProcesso }) {
  const { values, setValues } = valuesHook;
  const { finalizarProcessoModal, setFinalizarProcessoModal } = modalHook;

  return (
    <CommonModal
      title="Finalizar processo"
      is_open_modal={finalizarProcessoModal}
      set_is_open_modal={setFinalizarProcessoModal}
      size="lg"
      buttons={
        <CommonButton
          key={`novo-processo`}
          color="success"
          onClick={finalizarProcesso}
        >
          Salvar
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-lg-6 mb-3">
          <CommonInput
            label="E-mail"
            id="email"
            type="email"
            value={values.email}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
        <div className="col-lg-6 mb-3">
          <CommonInput
            label="Usuário"
            id="usuario"
            value={values.usuario}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 mb-3">
          <CommonInputSenha
            label="Senha"
            id="senha"
            value={values.senha}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
        <div className="col-lg-6 mb-3">
          <CommonInputSenha
            label="Confirme a senha"
            id="confirme_senha"
            value={values.confirme_senha}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-7 mb-3">
          <CommonInput
            label="Razão social"
            id="razao_social"
            value={values.razao_social}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
        <div className="col-lg-5 mb-3">
          <CommonInputMask
            label="CNPJ"
            id="cnpj"
            value={values.cnpj}
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            mask="99.999.999/9999-99"
            required
          />
        </div>
      </div>
      <div className="row align-items-center">
        <div className="col-lg-6 my-3">
          <label className="form-label requiredInput">Cartão CNPJ</label>
        </div>
        <div className="col-lg-6 my-3">
          <CommonInputFile
            label={null}
            accept="application/pdf"
            id="cartao_cnpj"
            onChange={(e) => handleChangeFile(e, values, setValues)}
            required
            data-arquivo="1"
          />
        </div>
      </div>
      <div className="row align-items-center">
        <div className="col-lg-6 my-3">
          <label className="form-label requiredInput">
            Certificado de condição do MEI (CCMEI)
          </label>
        </div>
        <div className="col-lg-6 my-3">
          <CommonInputFile
            label={null}
            accept="application/pdf"
            id="ccmei"
            onChange={(e) => handleChangeFile(e, values, setValues)}
            required
            data-arquivo="1"
          />
        </div>
      </div>
    </CommonModal>
  );
}

FinalizarMeiModal.propTypes = {
  modalHook: PropTypes.shape({
    finalizarProcessoModal: PropTypes.bool.isRequired,
    setFinalizarProcessoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  finalizarProcesso: PropTypes.func.isRequired,
};

export default FinalizarMeiModal;
